/// <reference path="../_references.ts"/>

module App.Login {
	import UserSession = App.User.UserSession;
	import ToastService = App.Utils.ToastService;

	export class LoginController {
		formData: {
			username: string,
			password: string
		};
		officeUi: string;

		static $inject = ['$state', '$window', 'LoginService', 'UserSession'];

		constructor(
			private $state: ng.ui.IStateService,
			private $window: ng.IWindowService,
			private LoginService: LoginService,
			private UserSession: UserSession
		) {
			this.formData = {
				username: null,
				password: null
			};

			this.officeUi = $window.officeUi;
		}

		userLogin(evt: ng.IAngularEvent) : boolean {
			evt.stopPropagation();
			evt.preventDefault();
			this.LoginService.authentication(this.formData.username, this.formData.password);

			return false;
		}
	}

	angular
        .module('login', [
			'ngMap'
		])
		.controller('LoginController', LoginController);
}